import { useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";
import type { DashboardEmbedList } from "@/api/types";

const STALE_MS = 5 * 60_000;

export function useDashboards() {
  return useQuery({
    queryKey: ["dashboards"],
    queryFn: ({ signal }) =>
      api<DashboardEmbedList>("/api/v1/dashboards", { signal }),
    staleTime: STALE_MS,
    placeholderData: (prev) => prev,
  });
}
